<template>
  <div class="categories container is-boxed-fluid">
    <h2 class="section-title centered with-line">{{$t('title')}}</h2>
    <div class="row row-3 gut-2">
      <div :class="category.col_class" v-for="(category, key) in categories" :key="key">
        <category :item="category" v-if="key!=3"></category>
        <div class="category-banner" v-else>
          <div>
            <h3>{{banner.title}}</h3>
            <div class="item-description">{{banner.description}}</div>
            <a :href="banner.cta_action" class="">
              <button class="linear-button">{{banner.cta_text}}</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Category from '@/components/items/Category'
export default {
  props: ['categories', 'banner'],
  components: {
    Category
  },
  i18n: {
    messages: {
      en: {
        button: 'SHOP NOW',
        title: 'CATEGORIES'
      },
      hy: {
        button: 'ԿԱՏԱՐԵԼ ԳՆՈՒՄՆԵՐ',
        title: 'ԿԱՏԵԳՈՐԻԱՆԵՐ'
      },
      ru: {
        button: 'ПОКУПКА СЕЙЧАС',
        title: 'КАТЕГОРИИ'
      }
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  .categories{
    margin-bottom: 80px;

    @include mq($ms){
      margin-bottom: 30px;
      .col-xs-12{
        padding-left: 0!important;
        padding-right: 0!important;
        padding-bottom: 15px!important;

        .item-image{
          min-height: 450px;
        }
      }
    }

    .category-banner{
      background-color: #d7cfbd;
      height: 100%;
      position: relative;

      @include mq($ms){
        padding-top: 80px;
      }

      &>div{
        position: absolute;
        bottom: 50px;
        left: 50px;
        max-width: 650px;

        @include mq($ms){
          position: relative;
          left: 0;
          bottom: 0;
          padding: 15px;
        }

        h3{
          text-transform: uppercase;
          margin-bottom: 20px;
          font-size: 46px;

          @include mq($ms){
            font-size: 24px;
            margin-top: 0;
          }
        }

        .item-description{
          margin-bottom: 20px;
        }
      }
    }
  }
</style>
